import Vue from 'vue';

const state = {};

const mutations = {};

const actions = {
  async fetchExecutionPublicWorksPg({dispatch}) {
    const {data, status} = await Vue.axios.get ('/execution_public_works');
    if (status != 200) {
      await dispatch ('generateSnackBarMessage', {
        message: 'Ocurrió un error al obtener los rubros',
        type: 'error',
      });
    }
    return {data, status};
  },
  async updateExecutionPublicWorksPg ({dispatch}, executionPublicWorksPg) {
    const formData = new FormData ();
    formData.append ('title_cover_page', executionPublicWorksPg.title_cover_page);
    formData.append ('more_information', executionPublicWorksPg.more_information);
    formData.append ('link', executionPublicWorksPg.link);
    if (executionPublicWorksPg.file_cover_page) {
      formData.append ('file_cover_page', executionPublicWorksPg.file_cover_page);
    }
    if (executionPublicWorksPg.file_cover_footer_page) {
      formData.append ('file_cover_footer_page', executionPublicWorksPg.file_cover_footer_page);
    }
    const {data, status} = await Vue.axios.post (
      `/execution_public_works/${executionPublicWorksPg.id}`,
      formData
    );
    if (status != 200 && status != 201 && status != 204) {
      await dispatch ('createResponseMessage', {
        message: data.message ||
          'Ocurrió un error actualizando los datos del rubro',
        type: 'error',
      });
    } else {
      await dispatch ('generateSnackBarMessage', {
        message: data.message || 'Se guardó correctamente',
        type: 'success',
      });
    }
    return {data, status};
  },
};

export default {state, mutations, actions};
